import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";

const UploadFileButton = ({
  handleFileChange,
  fileName,
  fileError,
  acceptedTypes = ["application/pdf"],
  errorMessage = "Invalid file type.",
  dragAndDrop = true,
  buttonLabel = "Upload File",
  buttonVariant = "contained",
  buttonStartIcon = null,
  sx = {},
  fullWidth = true,
}) => {
  const dispatch = useDispatch();
  const [isDragging, setIsDragging] = useState(false);

  const processFile = (file) => {
    if (!file) return;

    if (!acceptedTypes.includes(file.type)) {
      dispatch(
        setSnackbar({
          open: true,
          message: errorMessage,
          error: true,
        })
      );
      return;
    }

    handleFileChange({ target: { files: [file] } });
  };

  return (
    <Box
      sx={{
        p: dragAndDrop ? 2 : 0,
        border: dragAndDrop
          ? `2px dashed ${isDragging ? "#1976d2" : "rgba(0,0,0,0.2)"}`
          : "none",
        borderRadius: 2,
        transition: "border-color 0.2s ease, background-color 0.2s ease",
        backgroundColor: isDragging ? "rgba(25, 118, 210, 0.04)" : "transparent",
        textAlign: "center",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: dragAndDrop ? "rgba(25, 118, 210, 0.04)" : "transparent",
        },
        ...sx,
      }}
      {...(dragAndDrop && {
        onDragOver: (e) => {
          e.preventDefault();
          setIsDragging(true);
        },
        onDragLeave: () => setIsDragging(false),
        onDrop: (e) => {
          e.preventDefault();
          setIsDragging(false);
          processFile(e.dataTransfer.files[0]);
        },
      })}
    >
      <input
        type="file"
        id="file-upload"
        style={{ display: "none" }}
        accept={acceptedTypes.join(",")}
        onChange={(e) => {
          const file = e.target.files[0];
          processFile(file);
          e.target.value = null;
        }}
      />

      <label htmlFor="file-upload" style={{ width: fullWidth ? "100%" : "auto", display: "block" }}>
        <Button
          variant={buttonVariant}
          component="span"
          startIcon={buttonStartIcon}
          fullWidth={fullWidth}
          sx={{
            minHeight: "44px",
            fontWeight: 500,
            textTransform: "none",
          }}
        >
          {buttonLabel}
        </Button>
      </label>

      {dragAndDrop && (
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "text.secondary",
            fontStyle: "italic",
          }}
        >
          or drag & drop your file here
        </Typography>
      )}

      {fileName && (
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "text.secondary",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            wordBreak: "break-word",
          }}
        >
          📎 {fileName}
        </Typography>
      )}

      {fileError && (
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {fileError}
        </Typography>
      )}
    </Box>
  );
};

export default UploadFileButton;
